import { useQuery } from '@tanstack/react-query'
import api from '../../lib/api'
import type { SiteNoticePublicResponse } from '../../types/siteNotice'

export function useSiteNotice() {
  return useQuery<SiteNoticePublicResponse>({
    queryKey: ['siteNotice'],
    queryFn: async () => {
      const response = await api.get<SiteNoticePublicResponse>('/config/site-notice')
      return response.data
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  })
}
